import type { CSSProperties } from "react";

export function getSidebarThemeVars(): CSSProperties {
  const fg = process.env.REACT_APP_SIDEBAR_FG;
  if (!fg) return {} as CSSProperties;

  // Only set overrides when HAU env is provided.
  return {
    "--sidebar-fg": fg,
    "--sidebar-menu-muted-opacity": "0.75",
    "--sidebar-menu-sub-opacity": "0.9",
    "--sidebar-app-opacity": "0.85",
    "--sidebar-popup-item-opacity": "0.75",
    "--sidebar-hamburger-opacity": "0.85",
    "--sidebar-hamburger-hover-bg": "rgba(255, 255, 255, 0.1)",
    "--sidebar-hamburger-hover-opacity": "1",
  } as CSSProperties;
}
